export default __webpack_public_path__ + "static/media/logo.8e8ed9e0.png";